import { Component, OnInit, Input } from '@angular/core';
import { QuoteDetailsComponent } from '../quote-details.component';
import { QuoteSummary } from '../../../../../quote/models/quote.summary.interface';


@Component({
  selector: 'app-quote-details-mobile',
  templateUrl: './quote-details-mobile.component.html',
  styleUrls: ['./quote-details-mobile.component.scss']
})
export class QuoteDetailsMobileComponent extends QuoteDetailsComponent implements OnInit {


  @Input()
  public set id(value: number) {
    if (value) {
      this.refreshQuote(value);
    }
  }

  @Input()
  public set quoteSummary(value: QuoteSummary) {
    if (value && value.quote.quote_ID) {
      // clone object to keep changes local
      let quoteSummary = (<any>Object).assign({}, value) as QuoteSummary;
      this.loadQuote(quoteSummary);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();       
  }
}
